import Editor from './Editor'
import Preview from './Preview'

export default {
  Editor,
  Preview,
}
